import { axiosInstance } from '../../helpers/api_helper';

const updateBannerTwoInfoCard = async (formData: any) => {
  try {
    console.log('FormData in updateBannerTwoInfoCard:', formData);

    const response = await axiosInstance.patch(`/FrontPage/UpdateBannerTwoInfoCard`, formData);

    console.log('API Response from updateBannerTwoInfoCard:', response); // Log the response

    if (response.data.status === "00") {
      // Handle success, if needed
      return response.data;
    } else {
      // Handle error
      throw new Error('Error updating Banner Two Info Card details');
    }
  } catch (error:any) {
    // Handle network or other errors
    throw new Error(`Error: ${error.message}`);
  }
};

export { updateBannerTwoInfoCard };
